/**
 * Получаем массив из строки
 * @param string
 * @param isInt
 * @returns {*}
 */
function setParamArray(string, isInt = false) {
	let arr = string.split(',');

	if (isInt) {
		return arr.map((item) => {
			return parseInt('' + item)
		})
	} else {
		return arr;
	}
}

/**
 * Глубокое объединение объектов
 * @param objects
 * @returns {*}
 */
function mergeDeepObject(...objects) {
	const isObject = obj => obj && typeof obj === 'object';

	return objects.reduce((prev, obj) => {
		Object.keys(obj).forEach(key => {
			const pVal = prev[key];
			const oVal = obj[key];

			if (Array.isArray(pVal) && Array.isArray(oVal)) {
				prev[key] = pVal.concat(...oVal);
			} else if (isObject(pVal) && isObject(oVal)) {
				prev[key] = mergeDeepObject(pVal, oVal);
			} else {
				prev[key] = oVal;
			}
		});

		return prev;
	}, {});
}

/**
 * Color modes
 */
function getSystemTheme() {
	if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
		return 'dark';
	}

	return 'light'
}

/**
 * Если что-нибудь в объекте
 * @param obj
 * @returns {boolean}
 */
function isEmptyObj(obj) {
	for (let prop in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, prop)) {
			return false;
		}
	}

	return true
}

/**
 * isObject
 * @param obj
 * @returns {boolean}
 */
const isObject = obj => obj && typeof obj === 'object';

/**
 * isJsonString
 * @param str
 * @returns {boolean}
 */
function isJsonString(str) {
	try {
		str = JSON.parse(str);
	} catch (e) {
		return false;
	}
	return str;
}

/**
 * Демонтаж
 * @param func
 * @param wait
 * @param immediate
 * @returns {(function(): void)|*}
 */
function debounce(func, wait = 250, immediate = false) {
	let timeout = null;
	return function executedFunction() {
		let context = this,
			args = arguments,
			later = function () {
				timeout = null;
				if (immediate) func.apply(context, args);
			},
			callNow = immediate && !timeout;

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	}
}

/**
 * isElement
 * @param object
 * @returns {boolean}
 */
const isElement = object => {
	if (!isObject(object)) {
		return false
	}

	return typeof object.nodeType !== 'undefined'
}

/**
 * Callback
 * @param possibleCallback
 * @param args
 * @param defaultValue
 * @returns {*}
 */
function execute(possibleCallback, args = [], defaultValue = possibleCallback) {
	return typeof possibleCallback === 'function' ? possibleCallback(...args) : defaultValue
}

export {mergeDeepObject, setParamArray, getSystemTheme, isEmptyObj, isObject, isJsonString, debounce, isElement, execute}
